import { render, staticRenderFns } from "./ProductImagesCarousel.vue?vue&type=template&id=77fd4867&"
import script from "./ProductImagesCarousel.vue?vue&type=script&lang=js&"
export * from "./ProductImagesCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ProductImagesCarousel.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Carousel: require('/gitlab-runner-data/builds/ns-am/product/apps/catalog/components/Carousel.vue').default,Button: require('/gitlab-runner-data/builds/ns-am/product/apps/catalog/components/Button.vue').default})
